import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LoadingSpinner: React.FC = () => {
  const { t } = useTranslation();

  const spinnerIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <Spin indicator={spinnerIcon} tip={t('loading')} />
    </div>
  );
};

export default LoadingSpinner;
